/* Publish by EComposer at 2026-10-08 03:02:07*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-6f4p9mlcihp"]=  window.__ectimmers["ecom-6f4p9mlcihp"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),o=t.querySelector(".text-content.ecom-html");!o||(e&&e.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-6f4p9mlcihp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6f4p9mlcihp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r68j495ohy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r68j495ohy', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uaxxffok1jo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uaxxffok1jo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q3jwp3focjh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q3jwp3focjh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-juo1b1o2zbr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-juo1b1o2zbr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4vz21niskzi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4vz21niskzi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qggbtux7su').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qggbtux7su', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-evhoe6oricu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-evhoe6oricu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6o1j8n8j7g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6o1j8n8j7g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2l02dtafobi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2l02dtafobi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4idxvj1lron').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4idxvj1lron', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i8551xcbgy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i8551xcbgy', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jcmqyvbmvj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jcmqyvbmvj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9tq7ct6ws55').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9tq7ct6ws55', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-aqz8bx4rp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-aqz8bx4rp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vik05z2e4i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vik05z2e4i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x0n8dkznd9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x0n8dkznd9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5lif123ohtx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5lif123ohtx', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vd48v9nb6fg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vd48v9nb6fg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7xqn5qz7sxf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7xqn5qz7sxf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-48nudmcegqj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-48nudmcegqj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h7f2u5rktph').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h7f2u5rktph', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p714s0bu1t9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p714s0bu1t9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-td3yl11562').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-td3yl11562', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-rl0luzyl71"]=  window.__ectimmers["ecom-rl0luzyl71"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-rl0luzyl71"]["n30auweui"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let o=this.$el;if(!o)return;function n(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function s(){let r=o.querySelector(".ecom-element.ecom-base-image"),a=o.closest(".core__row--columns");r&&(n(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){s()})

                    });
                    
                        document.querySelectorAll('.ecom-rl0luzyl71').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rl0luzyl71', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nwolfz6dcp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nwolfz6dcp', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xo6pfaijcj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xo6pfaijcj', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vnb3b2gh8ph').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vnb3b2gh8ph', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kqr3oo2nehc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kqr3oo2nehc', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u5n9zbn7e6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u5n9zbn7e6', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-exdztuid47w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-exdztuid47w', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kplikvr1gbb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kplikvr1gbb', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y1a0fdto4i8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y1a0fdto4i8', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cpws95pec7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cpws95pec7', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lw5sqd1zuxk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lw5sqd1zuxk', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3sf2t4th3mm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3sf2t4th3mm', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ncgcxr7gfop').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ncgcxr7gfop', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s83b0noord').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s83b0noord', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tb52pqdvqu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tb52pqdvqu', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pqzt6s5zh9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pqzt6s5zh9', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2l2runzor89').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2l2runzor89', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}